import { render, staticRenderFns } from "./MaterialBillConfig.vue?vue&type=template&id=131eac2a&"
import script from "./MaterialBillConfig.vue?vue&type=script&lang=js&"
export * from "./MaterialBillConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports